import { createContext, useContext } from "react";

export const TOTAL_ARTICLES = 5;

export const NewsArticleContext = createContext<{
  articleIndex: number;
  setArticleIndex: (index: number) => void;
  viewedArticles: Set<number>;
  markAsViewed: (index: number) => void;
  unreadCount: number;
}>({
  articleIndex: 0,
  setArticleIndex: () => {},
  viewedArticles: new Set(),
  markAsViewed: () => {},
  unreadCount: TOTAL_ARTICLES,
});

export const useNewsArticle = () => useContext(NewsArticleContext);
